// extracted by mini-css-extract-plugin
export var closeButton = "_y-0";